import React from "react";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import Select from "react-select";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ButtonGroup,
  Button,
  Col,
  Row,
  Label,
  Input
} from "reactstrap";
import {
  conditionConstants,
  selectors,
  actions,
  operators
} from "../condition.constants";
import {
  OperatorSelector,
  operatorSelector
} from "../conditions.operator.selector";
import Checkbox from '@material-ui/core/Checkbox';
import { deepClone } from "../../../../../helpers/objectHelper";
import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";
import { eventDictionary, fieldDictionary, optionQuestionDictionary } from "../condition.dictionary";

class ConditionRow extends React.Component {
  componentDidMount() { }

  setPrefix = conditionPrefix => {
    let currentCondition = deepClone(this.props.currentCondition);

    if (currentCondition.prefix.includes("(")) {
      currentCondition.prefix = conditionPrefix + "(";
    } else {
      currentCondition.prefix = conditionPrefix;
    }
    this.props.update(currentCondition, this.props.index);
  };
  convertSourceList = () => {
    const { sourceList } = this.props;
    if (sourceList === undefined) {
      return [];
    }

    let fields = sourceList
      .filter(sl => sl.type == elementConstants.FIELD)
      .map((si, i) => {
        let textLabel = si.props.labels.find(
          l => l.languageCode == this.props.languageCode
        );
        return {
          label: textLabel.text,
          value: si.formElementId
        };
      });
    let questions = sourceList
      .filter(sl => sl.type == elementConstants.QUESTION)
      .map((si, i) => {
        let textLabel = si.props.labels.find(
          l => l.languageCode == this.props.languageCode
        );
        return {
          label: textLabel.text,
          value: si.formElementId
        };
      });
    let events = sourceList
      .filter(sl => sl.type == elementConstants.EVENT)
      .map((si, i) => {
        return {
          label: si.props.name,
          value: si.formElementId
        };
      });
    const groupedOptions = [];
    if (fields.length > 0)
      groupedOptions.push({
        label: "Fields",
        options: fields
      });
    if (questions.length > 0)
      groupedOptions.push({
        label: "Questions",
        options: questions
      });
    if (events.length > 0)
      groupedOptions.push({
        label: "Events",
        options: events
      });
    return groupedOptions;
  };

  convertOperators = () => {
    let operatorOptions = [];
    let source = this.props.sourceList.find(
      sl => sl.formElementId == this.props.currentCondition.sourceId
    );
    if (source) {
      switch (source.type) {
        case elementConstants.FIELD:
          for (const key in conditionConstants.fieldOperators) {
            if (conditionConstants.fieldOperators.hasOwnProperty(key)) {
              const element = conditionConstants.fieldOperators[key];
              const label = fieldDictionary(key)
              operatorOptions.push({ label: <SystemLabel name={label} />, value: key });
            }
          }

          break;
        case elementConstants.QUESTION:
          if (source.props.type == "Option") {
            for (const key in conditionConstants.questionOptionOperators) {
              if (
                conditionConstants.questionOptionOperators.hasOwnProperty(key)
              ) {
                const element = conditionConstants.questionOptionOperators[key];
                const label = optionQuestionDictionary(key)
                operatorOptions.push({ label: <SystemLabel name={label} />, value: key });
              }
            }
          } else {
            for (const key in conditionConstants.fieldOperators) {
              if (conditionConstants.fieldOperators.hasOwnProperty(key)) {
                const element = conditionConstants.fieldOperators[key];
                const label = fieldDictionary(key)
                operatorOptions.push({ label: <SystemLabel name={label} />, value: key });
              }
            }
          }
          break;
        case elementConstants.EVENT:
          for (const key in conditionConstants.eventOperators) {
            if (conditionConstants.eventOperators.hasOwnProperty(key)) {
              const element = conditionConstants.eventOperators[key];
              const label = eventDictionary(key)
              operatorOptions.push({ label: <SystemLabel name={label} />, value: key });
            }
          }
          break;
        default:
          break;
      }
    }
    return operatorOptions;
  };
  getValueInput = () => {
    let source = this.props.sourceList.find(
      sl => sl.formElementId == this.props.currentCondition.sourceId
    );
    let operator = this.props.currentCondition.operator;
    if (source) {
      switch (source.type) {
        case elementConstants.FIELD:
          switch (operator) {
            case conditionConstants.operators.EQUAL:
            case conditionConstants.operators.NOT_EQUAL:
            case conditionConstants.operators.LIKE:
              return {
                type: "text_input",
                value: this.props.currentCondition.value
              };
            case conditionConstants.operators.GREATER_THAN:
            case conditionConstants.operators.LESS_THAN:
            case conditionConstants.operators.LESS_THAN_OR_EQUAL_TO:
            case conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO:
              return {
                type: "number_input",
                value: this.props.currentCondition.value
              };
            case conditionConstants.operators.BETWEEN:
              return { type: "dual_text_input" };
            default:
              return { type: "none" };
          }
          break;
        case elementConstants.QUESTION:
          if (source.props.type == "Option") {
            switch (operator) {
              case conditionConstants.operators.EQUAL:
              case conditionConstants.operators.NOT_EQUAL:
                let selectedOption = undefined;
                let qOptions = source.props.options.map(o => {
                  if (o.optionId === this.props.currentCondition.value) {
                    selectedOption = {
                      label: o.labels.find(
                        ol => ol.languageCode === this.props.languageCode
                      ).text,
                      value: o.optionId
                    };
                  }
                  return {
                    label: o.labels.find(
                      ol => ol.languageCode === this.props.languageCode
                    ).text,
                    value: o.optionId
                  };
                });

                return {
                  type: "select",
                  selectedOption,
                  options: qOptions || []
                };

              case conditionConstants.operators.ANY:
              case conditionConstants.operators.NOT:
                return { type: "none" };
              default:
                return { type: "none" };
            }
          } else {
            switch (operator) {
              case conditionConstants.operators.EQUAL:
              case conditionConstants.operators.NOT_EQUAL:
              case conditionConstants.operators.LIKE:
                return {
                  type: "text_input",
                  value: this.props.currentCondition.value
                };
              case conditionConstants.operators.LESS_THAN_OR_EQUAL_TO:
              case conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO:
                return {
                  type: "number_input",
                  value: this.props.currentCondition.value
                };
              case conditionConstants.operators.BETWEEN:
                return { type: "dual_text_input" };
              default:
                return { type: "none" };
            }
          }
        case elementConstants.EVENT:
          switch (operator) {
            case conditionConstants.operators.EQUAL:
              return { type: "checkbox" };
            default:
              return { type: "none" };
          }
        default:
          return { type: "none" };
      }
    }
    return { type: "none" };
  };
  onChange = (param, value) => {
    let currentCondition = Object.assign({}, this.props.currentCondition);
    currentCondition[param] = value;
    switch (param) {
      case "sourceId":
        currentCondition.operator = "";
        currentCondition.value = "";
        break;
      default:
        break;
    }

    this.props.update(currentCondition, this.props.index);
  };
  getDashes = () => {
    const { currentCondition } = this.props;
    let str = "";
    for (let index = 0; index < currentCondition.indent; index++) {
      str += "---";
    }
    return str;
  };
  indentWrapper = (indent, content) => {
    if (indent == 0) return content;
    else if (indent == 1)
      return (
        <div
          style={{
            margin: "0 10px",
            backgroundColor: "#F5F5F5"
          }}
        >
          {content}
        </div>
      );
    else if (indent == 2) {
      return (
        <div
          style={{
            backgroundColor: "#F5F5F5",
            margin: "0 10px",
            borderLeft: "1px dotted #00000021",
            borderRight: "1px dotted #00000021",
            paddingTop: this.props.currentCondition.prefix.includes("(")
              ? "10px"
              : "0",
            paddingBottom: this.props.currentCondition.suffix.includes(")")
              ? "10px"
              : "0"
          }}
        >
          <div
            style={{
              backgroundColor: "#DCDCDC",
              margin: "0 10px"
            }}
          >
            {content}
          </div>
        </div>
      );
    }
  };
  render() {
    const { currentCondition } = this.props;
    let sourceList = this.convertSourceList();
    let operators = this.convertOperators();
    let sourceValue = "";
    sourceList.find(g => {
      let option = g.options.find(o => o.value == currentCondition.sourceId);
      if (option) {
        sourceValue = option;
        return true;
      } else return false;
    });
    return (
      <React.Fragment>
        {this.indentWrapper(
          currentCondition.indent,
          <React.Fragment>
            {this.props.index > 0 ? (
              <Row
                className="text-center"
                style={{
                  margin: "0",
                  borderLeft: !currentCondition.prefix.includes("(")
                    ? currentCondition.indent == 2
                      ? "1px dashed #00000021"
                      : currentCondition.indent == 1
                        ? "1px dotted #00000021"
                        : ""
                    : "",
                  borderRight: !currentCondition.prefix.includes("(")
                    ? currentCondition.indent == 2
                      ? "1px dashed #00000021"
                      : currentCondition.indent == 1
                        ? "1px dotted #00000021"
                        : ""
                    : "",
                  backgroundColor: currentCondition.prefix.includes("(")
                    ? currentCondition.indent == 1
                      ? "#FFF"
                      : currentCondition.indent == 2
                        ? "#F5F5F5"
                        : currentCondition.indent == 3
                          ? "#DCDCDC"
                          : "inherit"
                    : currentCondition.indent == 0
                      ? "#FFF"
                      : currentCondition.indent == 1
                        ? "#F5F5F5"
                        : currentCondition.indent == 2
                          ? "#DCDCDC"
                          : "inherit"
                }}
              >
                <Col md="5" style={{ margin: '15px 0px' }}>
                  {currentCondition.indent === 0 ? <hr /> : null}
                </Col>
                <Col md="2">
                  <ButtonGroup style={{ margin: '15px 0px' }}>
                    <Button
                      style={currentCondition.prefix.includes("AND") ? { backgroundColor: 'rgb(23, 162, 184)', color: '#fff' } : undefined}
                      color={
                        !currentCondition.prefix.includes("AND")
                          ?
                          "default" : ''
                      }
                      className="condition-separator-btn"
                      onClick={() => this.setPrefix("AND")}
                    >
                      <SystemLabel name="And" />
                    </Button>
                    <Button
                      style={currentCondition.prefix.includes("OR") ? { backgroundColor: 'rgb(23, 162, 184)', color: '#fff' } : undefined}
                      color={
                        !currentCondition.prefix.includes("OR")
                          ?
                          "default" : ''
                      }
                      className="condition-separator-btn"
                      onClick={() => this.setPrefix("OR")}
                    >
                      <SystemLabel name="Or" />
                    </Button>
                  </ButtonGroup>
                </Col>
                <Col md="5" style={{ margin: '15px 0px' }}>
                  {currentCondition.indent === 0 ? <hr /> : null}
                </Col>
              </Row>
            ) : null}
            <Row
              style={{
                margin: 0,
                borderLeft:
                  currentCondition.indent === 1
                    ? "1px dotted #00000021"
                    : currentCondition.indent === 2
                      ? "1px dashed #00000021"
                      : "",
                borderRight:
                  currentCondition.indent === 1
                    ? "1px dotted #00000021"
                    : currentCondition.indent === 2
                      ? "1px dashed #00000021"
                      : "",
                paddingTop: currentCondition.prefix.includes("(")
                  ? "10px"
                  : "0",
                borderTop: currentCondition.prefix.includes("(")
                  ? currentCondition.indent === 1
                    ? "1px dotted #00000021"
                    : "1px dashed #00000021"
                  : "",
                backgroundColor:
                  currentCondition.indent == 0
                    ? "#FFF"
                    : currentCondition.indent == 1
                      ? "#F5F5F5"
                      : currentCondition.indent == 2
                        ? "#DCDCDC"
                        : "inherit"
              }}
            >
              <Col md="3">
                <Select
                  className="condition-select"
                  value={sourceValue}
                  onChange={e => this.onChange("sourceId", e.value)}
                  options={sourceList}
                />
              </Col>
              <Col md="3">
                <Select
                  disabled={currentCondition.sourceId <= 0}
                  value={
                    currentCondition.operator &&
                    operators.find(s => {
                      return s.value === currentCondition.operator;
                    })
                  }
                  options={operators}
                  onChange={e => this.onChange("operator", e.value)}
                  className="condition-select"
                />
              </Col>
              <Col md="4">
                <Selector
                  disabled={
                    currentCondition.sourceId <= 0 || !currentCondition.operator
                  }
                  selector={this.getValueInput()}
                  onChange={this.onChange}
                />
              </Col>

              <Col md="2">
                <Button
                  style={{ backgroundColor: "#fff", display: "inline-flex" }}
                  className="condition-save-btn"
                  onClick={e => this.props.removeCondition(this.props.index)}
                >
                  <i
                    className="fa fa-trash"
                    style={{
                      fontSize: "16px",
                      color: "#4e4e4e",
                      marginRight: "5px"
                    }}
                    onClick={e => this.props.removeCondition(this.props.index)}
                  />
                  <SystemLabel name="Remove" />
                </Button>
              </Col>
            </Row>
            {this.props.currentCondition.indent > 0 ? (
              <Row
                style={{
                  paddingTop: "3px",
                  margin: "0",
                  borderLeft:
                    currentCondition.indent === 1
                      ? "1px dotted #00000021"
                      : currentCondition.indent === 2
                        ? "1px dashed #00000021"
                        : "",
                  borderRight:
                    currentCondition.indent === 1
                      ? "1px dotted #00000021"
                      : currentCondition.indent === 2
                        ? "1px dashed #00000021"
                        : "",
                  paddingBottom: currentCondition.suffix.includes(")")
                    ? "10px"
                    : "0",
                  borderBottom: this.props.currentCondition.suffix.includes(")")
                    ? currentCondition.indent === 1
                      ? "1px dotted #00000021"
                      : currentCondition.indent === 2
                        ? "1px dashed #00000021"
                        : ""
                    : "",
                  backgroundColor:
                    currentCondition.indent == 0
                      ? "#FFF"
                      : currentCondition.indent == 1
                        ? "#F5F5F5"
                        : currentCondition.indent == 2
                          ? "#DCDCDC"
                          : "inherit"
                }}
              >
                <Col md="12">
                  {"    "}
                  <Button
                    style={{ backgroundColor: "#fff", marginRight: '2px' }}
                    size="sm"
                    onClick={e => this.props.addCondition(this.props.index)}
                  >
                    <SystemLabel name="Add" />
                  </Button>
                  {" "}
                  {this.props.currentCondition.indent < 2 ? (
                    <Button
                      style={{ backgroundColor: "#fff" }}
                      size="sm"
                      onClick={e =>
                        this.props.addConditionGroup(this.props.index)
                      }
                    >
                      <SystemLabel name="Group" />
                    </Button>


                  ) : null}
                </Col>
              </Row>
            ) : null}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
export default ConditionRow;

const Selector = props => {
  const { onChange, selector } = props;
  switch (selector.type) {
    case "checkbox":
      return (
        /*      <input
               className="condition"
               type="checkbox"
               onChange={e => onChange("value", e.checked)}
             /> */
        <Checkbox
          checked={selector.value}
          style={{
            color: 'rgb(23, 162, 184)',
            padding: '5px'
          }}
          onChange={e => onChange("value", e.target.checked)}
          value="primary"
          color="red"
        /*   inputProps={{ 'aria-label': 'primary checkbox' }} */
        />

      );
    case "select":
      return (
        <Select
          value={selector.selectedOption}
          options={selector.options}
          className="condition"
          onChange={e => onChange("value", e.value)}
        />
      );
    case "text_input":
      return (
        <Input
          className="condition"
          value={selector.value}
          type="text"
          onChange={e => onChange("value", e.target.value)}
        />
      );
    case "number_input":
      return (
        <Input
          className="condition"
          value={selector.value}
          type="number"
          onChange={e => onChange("value", e.target.value)}
        />
      );
    case "dual_text_input":
      return (
        <React.Fragment>
          <Input
            className="condition"
            type="text"
            onChange={onChange}
            style={{ display: "inline", width: "40%" }}
          />
          <Label
            className="text-muted"
            style={{ width: "10%", display: "inline" }}
          >
            <SystemLabel name="BetweenText" />
          </Label>
          <Input
            className="condition"
            type="text"
            onChange={onChange}
            style={{ display: "inline", width: "40%" }}
          />
        </React.Fragment>
      );
    default:
      return null;
  }
};
